import backGround from "../assets/images/backGround.jpg";
import homePage1 from "../assets/images/homePage/1.jpg";
import homePage2 from "../assets/images/homePage/2.jpg";
import homePage4 from "../assets/images/homePage/4.jpg";
import homePage6 from "../assets/images/homePage/6.jpg";
import homePage7 from "../assets/images/homePage/7.jpg";

export const HERO_SLIDES = [
  {
    backgroundImage: backGround,
    blendClass: "style-blend-mode",
    titleKey: "Sports Flooring",
    subtitleKey:
      "Explore our premium sports flooring options at Caf Sports, designed for superior performance and safety. Contact us today for customized solutions and expert guidance",
    subtitleSize: "sm",
  },
  {
    backgroundImage: homePage1,
    blendClass: "style-blend-mode",
    titleKey: "Customized Style",
    subtitleKey:
      "Indulge in the Luxury of Tailored Style, Crafted Exclusively for You",
  },
  {
    backgroundImage: homePage2,
    blendClass: "style-blend-mode-homePage2",
    titleKey: "Unmatched Durability",
    subtitleKey:
      "Experience Unparalleled Endurance Unmatched Durability That Stands the Test of Time",
  },
  {
    backgroundImage: homePage4,
    blendClass: "style-blend-mode",
    titleKey: "Elevate Performance",
    subtitleKey:
      "Rise Above the Rest Elevate Your Performance to Extraordinary Levels",
  },
  {
    backgroundImage: homePage6,
    blendClass: "style-blend-mode",
    titleKey: "Versatile Solutions",
    subtitleKey: "Discover Versatile Solutions Tailored to Meet Your Every Need",
  },
  {
    backgroundImage: homePage7,
    blendClass: "style-blend-mode",
    titleKey: "Improve the performance",
    subtitleKey:
      "Unleash Your Potential with Premier Sports Flooring. Elevate Performance, Enhance Safety. Explore Now",
  },
];
